export default import.meta.ROLLUP_FILE_URL_HRipoy97gX_OcRZdFVk1qQ